import React from "react";

import { WorkOrder } from "../../../../models/workOrder";
import WorkOrderTimeZoneSelectorPresenter from "./presenter";

interface WorkOrderTimeZoneSelectorProps {
  workOrder: WorkOrder;
  onTimezoneSelected: (timezone: string) => void;
}

const WorkOrderTimeZoneSelector: React.FC<WorkOrderTimeZoneSelectorProps> = ({
  workOrder,
  onTimezoneSelected,
}) => {
  return (
    <>
      <WorkOrderTimeZoneSelectorPresenter
        selectedTimeZone={workOrder.serviceScheduleTimezone}
        onTimezoneSelected={onTimezoneSelected}
      />
    </>
  );
};

export default WorkOrderTimeZoneSelector;
